<script>
  import countTo from "vue-count-to";
  import Statistics from "@/services/Statistics";
  import General from "@/services/General";
  import Teams from "@/services/Teams";
  import modalEditPreviewText from "@/components/modals/dashboard/modalEditPreviewText";
  import Notification from "@/services/Notification";
  
  /**
   * Stat component
   */
   export default {
    components: {
      countTo,
      modalEditPreviewText,
    },
    data() {
      return {
        graph_type_users: "daily",
        graph_type_orders: "daily",
        notifDataLoader: false,
        topProductLoader: false,
        loaderRegUsers: false,
        loaderOrders: false,
        loaderUsersByGender: false,
        loaderUsersByAge: false,
        loaderMotm: false,
        loaderGts: false,
        colorMap: {
        pink: '#ec4899',
        blue: '#3b82f6',
        green: '#22c55e',
        orange: '#f97316'
         },
        // FIXED: Use only ONE series property for the users chart
        usersSeries: [], // This is for the users chart
        
        // Remove the conflicting series property from data()
        // series: [ { data: [0] } ], // DELETE THIS LINE - It's causing conflicts
        
      usersByGenderData: [],
      usersByGenderTotal: 0,
      usersByGenderOptions: {
          chart: { 
            type: 'bar', 
            height: 280, // Increased to accommodate legend
            toolbar: { show: false },
            stacked: false
          },
          plotOptions: {
            bar: {
              horizontal: true,
              columnWidth: '50%',
              borderRadius: 4,
              distributed: true, // Each bar gets its own color
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val, opts) {
              const count = val || 0;
              try {
                const seriesData = opts.w.globals.series[0] || [];
                const total = seriesData.reduce((a, b) => a + b, 0);
                const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : '0.0';
                return `${percentage}% (${count.toLocaleString()})`;
              } catch (e) {
                return count.toLocaleString();
              }
            },
            style: {
              fontSize: '12px',
              fontWeight: 600,
              colors: ['#fff']
            },
            offsetX: 10
          },
          xaxis: {
            categories: [],
            labels: {
              style: { fontSize: '13px', fontWeight: 500 }
            }
          },
          yaxis: {
            labels: {
              style: { fontSize: '12px' }
            }
          },
          colors: [], // Will be set dynamically based on categories
          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '12px',
            itemMargin: {
              horizontal: 10,
              vertical: 0
            },
            markers: {
              width: 12,
              height: 12,
              radius: 0
            }
          },
          grid: {
            padding: { top: 0, right: 140, bottom: 50, left: 0 },
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } }
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val.toLocaleString() + ' users';
              }
            }
          },
          noData: { text: 'No data available' },
        },
        
      usersByAgeData: [],
      usersByAgeTotal: 0,
        usersByAgeOptions: {
          chart: { 
            type: 'bar', 
            height: 240, 
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              horizontal: true,
              columnWidth: '50%',
              borderRadius: 4,
              distributed: false,
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val.toLocaleString();
            },
            style: {
              fontSize: '12px',
              fontWeight: 600,
              colors: ['#fff']
            },
            offsetX: 10
          },
          xaxis: {
            categories: [],
            labels: {
              style: { fontSize: '12px' }
            }
          },
          yaxis: {
            labels: {
              style: { fontSize: '12px' }
            }
          },
          colors: ['#f97316'], // Orange color
          grid: {
            padding: { top: 0, right: 120, bottom: 0, left: 0 },
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } }
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val.toLocaleString() + ' users';
              }
            }
          },
          noData: { text: 'No data available' },
        },
        
        // FIXED: Add borderRadius to usersChartOptions
        usersChartOptions: {
          chart: {
            width: "100%",
            height: 320,
            parentHeightOffset: 0,
            type: "bar",
            stacked: false,
            toolbar: { show: false },
          },
          noData: {
            text: 'No data available',
            align: 'center',
            verticalAlign: 'middle',
            style: { color: '#6c757d', fontSize: '16px' },
          },
          // FIXED: Add plotOptions with borderRadius
          plotOptions: {
            bar: {
              columnWidth: "85%", // Changed from 50% to 85%
              horizontal: false,
              borderRadius: 10, // Add borderRadius
              borderRadiusApplication: 'around',
              borderRadiusWhenStacked: 'last',
              distributed: false,
              endingShape: 'rounded'
            },
          },
          stroke: {
            width: 0, // Changed from [1, 5] to 0 for bar chart
            curve: "smooth",
          },
          dataLabels: { enabled: false },
          fill: {
            opacity: 1, // Changed from [0.85, 1] to 1 for bar chart
          },
          colors: ["#00c48c"], // Changed to match your screenshot color
          markers: { size: 0 },
          xaxis: {
            labels: {
              style: {
                fontSize: '10px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              }
            },
            type: "category",
            categories: [] // Add categories array
          },
          yaxis: {
            title: { text: "" },
            labels: {
              formatter: function (val) {
                return val ? val.toFixed(0) : "0";
              },
            },
            min: 0,
            // max will be set dynamically
          },
          tooltip: {
            shared: false,
            intersect: true,
            y: {
              formatter: function(y) {
                if (typeof y !== "undefined") {
                  return y.toFixed(0);
                }
                return y;
              },
            },
          },
          grid: {
            borderColor: "#f1f3fa",
            strokeDashArray: 3,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } },
          },
        },
  
        // Orders chart data
        ordersSeries: [],
        ordersChartOptions: {
          chart: {
            width: "100%",
            height: 320,
            parentHeightOffset: 0,
            type: "line",
            stacked: false,
            toolbar: { show: false },
          },
          noData: {
            text: 'No data available',
            align: 'center',
            verticalAlign: 'middle',
            style: { color: '#6c757d', fontSize: '16px' },
          },
          stroke: {
            show: true,
            width: [3, 3, 3],
            curve: "smooth",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              borderRadius: 0,
            },
          },
          dataLabels: { enabled: false },
          fill: {
            opacity: 0, // Default to no fill for line charts
            type: 'solid'
          },
          colors: ["#a855f7", "#f97316", "#3b82f6"], // Purple, Orange, Blue
          markers: { size: 0 },
          xaxis: {
            categories: [],
            labels: {
              style: {
                fontSize: '11px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
              },
              rotate: 0,
              rotateAlways: false,
            },
            type: "category",
          },
          legend: { 
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '12px',
            markers: {
              width: 12,
              height: 12,
              radius: 10,
            },
          },
          yaxis: {
            title: { text: "" },
            labels: {
              formatter: function(val) {
                if (val >= 1000) {
                  return "€" + (val / 1000).toFixed(0) + "k";
                }
                return val ? "€" + val.toFixed(0) : "€0";
              },
              style: {
                fontSize: '11px',
                fontFamily: 'Helvetica, Arial, sans-serif',
              },
            },
            min: 0,
          },
          grid: {
            borderColor: "#f1f3fa",
            strokeDashArray: 3,
            yaxis: { 
              lines: { show: true },
            },
            xaxis: { 
              lines: { show: false },
            },
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function(y) {
                if (typeof y !== "undefined") {
                  return "€" + y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                }
                return y;
              },
            },
          },
        },
        
        // MOTM (Man of the Match) chart data
        motmSeries: [],
        motmChartOptions: {
          chart: {
            width: "100%",
            height: 320,
            parentHeightOffset: 0,
            type: "bar",
            stacked: false,
            toolbar: { show: false },
          },
          noData: {
            text: 'No data available',
            align: 'center',
            verticalAlign: 'middle',
            style: { color: '#6c757d', fontSize: '16px' },
          },
          plotOptions: {
            bar: {
              columnWidth: "85%",
              horizontal: false,
              borderRadius: 10,
              borderRadiusApplication: 'around',
              borderRadiusWhenStacked: 'last',
              distributed: false,
              endingShape: 'rounded'
            },
          },
          stroke: {
            width: 0,
            curve: "smooth",
          },
          dataLabels: { enabled: false },
          fill: {
            opacity: 1,
          },
          colors: ["#3B82F6"],
          markers: { size: 0 },
          xaxis: {
            labels: {
              style: {
                fontSize: '10px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
              },
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
              showDuplicates: true,
              maxHeight: 120,
            },
            type: "category",
            categories: []
          },
          yaxis: {
            title: { text: "" },
            labels: {
              formatter: function (val) {
                return val ? val.toFixed(0) : "0";
              },
            },
            min: 0,
          },
          tooltip: {
            shared: false,
            intersect: true,
            y: {
              formatter: function(y) {
                if (typeof y !== "undefined") {
                  return y.toFixed(0) + " votes";
                }
                return y;
              },
            },
          },
          grid: {
            borderColor: "#f1f3fa",
            strokeDashArray: 3,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } },
          },
        },
        motmLoader: false,
        motmTotalVotes: 0,
        
        // GTS (Guess the Score) chart data
        gtsSeries: [],
        gtsChartOptions: {
          chart: {
            width: "100%",
            height: 320,
            parentHeightOffset: 0,
            type: "bar",
            stacked: false,
            toolbar: { show: false },
          },
          noData: {
            text: 'No data available',
            align: 'center',
            verticalAlign: 'middle',
            style: { color: '#6c757d', fontSize: '16px' },
          },
          plotOptions: {
            bar: {
              columnWidth: "85%",
              horizontal: false,
              borderRadius: 10,
              borderRadiusApplication: 'around',
              borderRadiusWhenStacked: 'last',
              distributed: false,
              endingShape: 'rounded'
            },
          },
          stroke: {
            width: 0,
            curve: "smooth",
          },
          dataLabels: { enabled: false },
          fill: {
            opacity: 1,
          },
          colors: ["#3B82F6"],
          markers: { size: 0 },
          xaxis: {
            labels: {
              style: {
                fontSize: '10px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
              },
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
              showDuplicates: true,
              maxHeight: 120,
            },
            type: "category",
            categories: []
          },
          yaxis: {
            title: { text: "" },
            labels: {
              formatter: function (val) {
                return val ? val.toFixed(0) : "0";
              },
            },
            min: 0,
          },
          tooltip: {
            shared: false,
            intersect: true,
            y: {
              formatter: function(y) {
                if (typeof y !== "undefined") {
                  return y.toFixed(0) + " votes";
                }
                return y;
              },
            },
          },
          grid: {
            borderColor: "#f1f3fa",
            strokeDashArray: 3,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } },
          },
        },
        gtsTotalVotes: 0,
        
        // For realtime chart (separate from users chart)
        realtimeSeries: [
          {
            data: [0],
          },
        ],
        realtimeOptions: {
          chart: { id: "vuechart-example" },
          xaxis: { categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998] },
        },
        
        // ... rest of your data properties (unchanged)
        showRegisteredUsers: false,
        showActiveSession: false,
        showOrders: false,
        showTicketing: false,
        user_count: 0,
        user_count_weekly: 0,
        user_count_weekly_prev: 0,
        orders_total: 0.0,
        orders_count: 0,
        change_percent: 0,
        sessions_change_percent: 0,
        sessions_count_current: 0,
        sessions_count_previous: 0,
        ticketing_orders_total: 0,
        ticketing_change_percent: 0,
        ticketing_count_current: 0,
        ticketing_count_previous: 0,
        days: 30,
        graph_days: 30,
        graph_months: 12,
        graph_type: "daily",
        graph_data_type: "customerDevices",
        message_text: "",
        message_button_text: "",
        message_button_link: "",
        message_button_color: "",
        message_button_text_color: "",
        message_image_url: "",
        message_video_url: "",
        message_background_color: "",
        button_color: "",
        button_text_color: "",
        message_text_color: "#ffffff",
        message_show: false,
        showMessageVideoModal: false,
        dashboard_version: process.env.VUE_APP_VERSION,
        showLoader: false,
        matches: [],
        currentMatchIndex: 0,
        secondMatch: [],
        modalData: {},
        topMerchProducts: [],
        dateOption: 'monthly',
        dateRange: [],
        isBusy: false,
        perPage: 10,
        currentPage: 1,
        sortBy: 'total_revenue',
        sortDesc: true,
        notificationsData: [],
        notificationsPeriodType: "monthly",
        
        // Sales chart (different from users chart)
        salesSeries: [
          { name: "Merchandising", type: "column", data: [] },
          { name: "Ewallet", type: "area", data: [] },
          { name: "Ticketing", type: "line", data: [] },
        ],
        salesChartOptions: {
          chart: {
            width: "100%",
            height: 350,
            type: "bar",
            stacked: false,
            toolbar: { show: false },
          },
          noData: {
            text: 'No data available',
            align: 'center',
            verticalAlign: 'middle',
            style: { color: '#6c757d', fontSize: '16px' },
          },
          stroke: { width: [1, 2, 5], curve: "smooth" },
          plotOptions: { bar: { columnWidth: "50%" } },
          dataLabels: { enabled: false },
          fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
              inverseColors: false,
              shade: "light",
              type: "vertical",
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100],
            },
          },
          colors: ["#5b73e8", "#e8e9eb", "#f1b54d"],
          labels: [],
          markers: { size: 0 },
          xaxis: { type: "text" },
          yaxis: [
            { title: { text: "" } },
            { opposite: true, title: { text: "" } },
          ],
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function(y) {
                if (typeof y !== "undefined") {
                  return y.toFixed(0) + "";
                }
                return y;
              },
            },
          },
          animations: {
            enabled: true,
            easing: "linear",
            speed: 1500,
            animateGradually: { enabled: true, delay: 1500 },
            dynamicAnimation: { enabled: true, speed: 1500 },
          },
        },
        
        // ... rest of chart options (unchanged)
        growthChartOptions: {
          fill: { colors: ["#f1b44c"] },
          chart: {
            type: "bar",
            sparkline: { enabled: true },
            width: "100%",
            height: 350,
          },
          plotOptions: { bar: { columnWidth: "50%" } },
          labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
          xaxis: { crosshairs: { width: 1 } },
          tooltip: {
            fixed: { enabled: false },
            x: { show: false },
            y: { title: { formatter: function() { return ""; } } },
            marker: { show: false },
          },
        },
        orderseries: [70],
        orderRadial: {
          fill: { colors: ["#34c38f"] },
          chart: { sparkline: { enabled: true } },
          dataLabels: { enabled: false },
          plotOptions: {
            radialBar: {
              hollow: { margin: 0, size: "60%" },
              track: { margin: 0 },
              dataLabels: { show: false },
            },
          },
        },
        customerseries: [55],
        customerRadial: {
          fill: { colors: ["#5b73e8"] },
          chart: { sparkline: { enabled: true } },
          dataLabels: { enabled: false },
          plotOptions: {
            radialBar: {
              hollow: { margin: 0, size: "60%" },
              track: { margin: 0 },
              dataLabels: { show: false },
            },
          },
        },
        orders_merchandising: [],
        showOrdersStatistics: true,
      };
    },
    
    async created() {
      this.showRegisteredUsers = await this.checkObjectAccessCall('kpi.dashboard.registered_users');
      this.showActiveSession = await this.checkObjectAccessCall('kpi.dashboard.active_session');
      this.showOrders = await this.checkObjectAccessCall('kpi.dashboard.orders');
      this.showTicketing = await this.checkObjectAccessCall('kpi.dashboard.ticketing');
    },
    
    computed: {
      computedMessageText() {
        if (this.message_text && this.message_text.trim() !== "") {
          return this.message_text;
        }
        return "Stay up to date with the latest activity and insights from your dashboard.";
      },
      computedMessageBackground() {
        if (this.message_background_color && this.message_background_color.trim() !== "") {
          return this.message_background_color;
        }
        return "#5b73e8";
      },
      computedMessageTextColor() {
        if (this.message_text_color && this.message_text_color.trim() !== "") {
          return this.message_text_color;
        }
        return "#ffffff";
      },
      computedButtonColor() {
        if (this.button_color && this.button_color.trim() !== "") {
          return this.button_color;
        }
        return "#34c38f";
      },
      computedButtonTextColor() {
        if (this.button_text_color && this.button_text_color.trim() !== "") {
          return this.button_text_color;
        }
        return "#ffffff";
      },
      avgDailyNewRegistrations() {
        if (!this.usersSeries || this.usersSeries.length === 0) return 0;
        const firstSeries = this.usersSeries[0];
        if (!firstSeries || !firstSeries.data || firstSeries.data.length === 0) return 0;
        
        // Calculate average of all daily values
        const sum = firstSeries.data.reduce((acc, val) => acc + (val || 0), 0);
        return sum / firstSeries.data.length;
      },
      lastDayNewRegistrations() {
        if (!this.usersSeries || this.usersSeries.length === 0) return 0;
        const firstSeries = this.usersSeries[0];
        if (!firstSeries || !firstSeries.data || firstSeries.data.length === 0) return 0;
        
        // Get the last value in the data array
        return firstSeries.data[firstSeries.data.length - 1] || 0;
      },
      avgDailyNewRegistrationsChangePercent() {
        if (!this.usersSeries || this.usersSeries.length === 0) return null;
        const firstSeries = this.usersSeries[0];
        if (!firstSeries || !firstSeries.data || firstSeries.data.length < 2) return null;
        
        // Compare first half vs second half of the period
        const data = firstSeries.data;
        const midPoint = Math.floor(data.length / 2);
        const firstHalf = data.slice(0, midPoint);
        const secondHalf = data.slice(midPoint);
        
        const firstHalfAvg = firstHalf.reduce((acc, val) => acc + (val || 0), 0) / firstHalf.length;
        const secondHalfAvg = secondHalf.reduce((acc, val) => acc + (val || 0), 0) / secondHalf.length;
        
        if (!firstHalfAvg || firstHalfAvg <= 0) return null;
        
        return ((secondHalfAvg - firstHalfAvg) / firstHalfAvg) * 100;
      },
      notificationsTotalSuccess() {
        if (!this.notificationsData || this.notificationsData.length === 0) return 0;
        return this.notificationsData.reduce((sum, notif) => sum + (notif.success || 0), 0);
      },
      notificationsTotalFailed() {
        if (!this.notificationsData || this.notificationsData.length === 0) return 0;
        return this.notificationsData.reduce((sum, notif) => sum + (notif.error || 0), 0);
      },
      notificationsTotalClicks() {
        if (!this.notificationsData || this.notificationsData.length === 0) return 0;
        return this.notificationsData.reduce((sum, notif) => sum + (notif.clicks || 0), 0);
      },
      bestSellersTotalRevenue() {
        if (!this.topMerchProducts || this.topMerchProducts.length === 0) return 0;
        return this.topMerchProducts.reduce((sum, product) => {
          const revenue = parseFloat(product.total_revenue) || 0;
          return sum + revenue;
        }, 0);
      },
      avgDailyRevenue() {
        if (!this.ordersSeries || this.ordersSeries.length === 0) return 0;
        // Sum all revenue streams for each day, then average
        let totalRevenue = 0;
        let dayCount = 0;
        const firstSeries = this.ordersSeries[0];
        if (firstSeries && firstSeries.data) {
          dayCount = firstSeries.data.length;
          for (let i = 0; i < dayCount; i++) {
            let dayTotal = 0;
            this.ordersSeries.forEach(series => {
              if (series.data && series.data[i] !== undefined) {
                dayTotal += series.data[i] || 0;
              }
            });
            totalRevenue += dayTotal;
          }
        }
        return dayCount > 0 ? totalRevenue / dayCount : 0;
      },
      lastDayRevenue() {
        if (!this.ordersSeries || this.ordersSeries.length === 0) return 0;
        // Sum all revenue streams for the last day
        let lastDayTotal = 0;
        this.ordersSeries.forEach(series => {
          if (series.data && series.data.length > 0) {
            const lastValue = series.data[series.data.length - 1] || 0;
            lastDayTotal += lastValue;
          }
        });
        return lastDayTotal;
      },
    },
    
    async mounted() {
      this.getCustomerDevicesStatistics();
      this.getOrdersStatisticsByTypeTotalCount();
      this.getCustomerStatistics();
      this.getOrdersTotalsStatistics();
      this.getSessionsStatistics();
      this.getTicketingTotalsStatistics();
      this.getDashboardMessage();
      this.getSportMatchesCurrent();
      this.getOrdersStatisticsByType();
      this.getNotificationsStatistics();
      this.getTopMerchandiseProducts();
      this.getUsersByGender();
      this.getUsersByAge();
      this.getMotmParticipationStats();
      this.getGtsParticipationStats();
    },
    
    methods: {
    async getUsersByGender() {
      this.loaderUsersByGender = true;
      try {
        const res = await Statistics.getUsersByGender();
        const rows = res.data.data || [];
        const data = rows.map(r => Number(r.count));
        const labels = rows.map(r => r.gender_group ?? 'Unknown');
        
        // Calculate total
        this.usersByGenderTotal = data.reduce((sum, count) => sum + count, 0);
        
        // Format data for HTML template: Sort: Male first, then Female, then Unknown/others
        const genderData = [];
        const genderOrder = ['Male', 'Female', 'Unknown'];
        
        // Add genders in order if they exist
        genderOrder.forEach(gender => {
          const index = labels.findIndex(l => l.toLowerCase() === gender.toLowerCase());
          if (index !== -1) {
            const count = data[index];
            const percentage = this.usersByGenderTotal > 0 ? ((count / this.usersByGenderTotal) * 100).toFixed(1) : '0.0';
            const labelLower = labels[index].toLowerCase();
            let color = 'blue'; // default
            if (labelLower === 'female') {
              color = 'pink';
            } else if (labelLower === 'unknown') {
              color = 'green'; // or 'orange' if you prefer
            }
            
            genderData.push({
              label: labels[index],
              count: count,
              percentage: parseFloat(percentage),
              color: color
            });
          }
        });
        
        // Add any other genders not in the order list
        labels.forEach((label, index) => {
          if (!genderOrder.some(g => g.toLowerCase() === label.toLowerCase())) {
            const count = data[index];
            const percentage = this.usersByGenderTotal > 0 ? ((count / this.usersByGenderTotal) * 100).toFixed(1) : '0.0';
            
            genderData.push({
              label: label,
              count: count,
              percentage: parseFloat(percentage),
              color: 'blue'
            });
          }
        });
        
        this.usersByGenderData = genderData;
      } catch (e) {
        // ignore
      } finally {
        this.loaderUsersByGender = false;
      }
    },

    getColorForGender(colorKey) {
      return this.colorMap[colorKey] || '#3b82f6';
    },
  
    async getUsersByAge() {
      this.loaderUsersByAge = true;
      try {
        const res = await Statistics.getUsersByAge();
        const rows = res.data.data || [];
        const data = rows.map(r => Number(r.count));
        const labels = rows.map(r => r.age_bucket);
        
        // Calculate total
        this.usersByAgeTotal = data.reduce((sum, count) => sum + count, 0);
        
        // Format data for HTML template
        // Reverse order so that Unknown (if exists) or first category appears at top
        const reversedLabels = [...labels].reverse();
        const reversedData = [...data].reverse();
        
        const ageData = reversedLabels.map((label, index) => {
          const count = reversedData[index];
          const percentage = this.usersByAgeTotal > 0 ? ((count / this.usersByAgeTotal) * 100).toFixed(1) : '0.0';
          
          return {
            label: label,
            count: count,
            percentage: parseFloat(percentage)
          };
        });
        
        this.usersByAgeData = ageData;
      } catch (e) {
        // ignore
      } finally {
        this.loaderUsersByAge = false;
      }
      },
    
    async getCustomerDevicesStatistics() {
        this.loaderRegUsers = true;
        try {
          const days = this.graph_type_users === "daily" ? this.graph_days : this.graph_months;
          const response = await Statistics.getCustomerDevicesStatistics(days, this.graph_type_users, {});
          
          const apiData = response.data.data;
          
          // FIXED: Assign to usersSeries (not series)
          this.usersSeries = apiData.data;
          
          // Update chart options
          this.usersChartOptions = {
            ...this.usersChartOptions,
            xaxis: {
              ...this.usersChartOptions.xaxis,
              categories: apiData.labels
            }
          };
          
          // Calculate max value for y-axis
          if (apiData.data && apiData.data.length > 0 && apiData.data[0].data) {
            const maxValue = Math.max(...apiData.data[0].data);
            this.usersChartOptions.yaxis = {
              ...this.usersChartOptions.yaxis,
              max: Math.ceil(maxValue * 1.1)
            };
          }
          
          // Update chart
          await this.$nextTick();
          
          if (this.$refs.usersChart) {
            // Update series and options
            this.$refs.usersChart.updateSeries(this.usersSeries, false);
            
            this.$refs.usersChart.updateOptions({
              xaxis: { categories: apiData.labels },
              yaxis: this.usersChartOptions.yaxis
            }, false, false);
            
            // Force redraw
            this.$refs.usersChart.refresh();
          }
          
        } catch (error) {
          this.error = error.response?.data?.error || '';
          this.failedmsg(this.error);
        } finally {
          this.loaderRegUsers = false;
        }
      },
  
      async getOrdersStatisticsByType() {
        this.loaderOrders = true;
        let updateData = null; // Declare outside try block for use in finally
        
        try {
          const days = this.graph_type_orders === "daily" ? this.graph_days : this.graph_months;
          const response = await Statistics.getOrdersStatisticsByType(days, this.graph_type_orders, {});
          
          // Transform API data to ApexCharts format (remove 'type' property from series)
          const rawSeries = response.data.data.data || [];
          this.ordersSeries = rawSeries.map(series => ({
            name: series.name,
            data: series.data || []
          }));
  
          const charts = response.data.data.charts || [];
          const dynamicColors = charts.map(c => c.colors).filter(c => c);
          
          // Ensure stroke widths match the number of series
          const strokeWidths = this.ordersSeries.map((series, index) => {
            const chartConfig = charts[index] || charts.find(c => c.label_name === series.name);
            if (chartConfig) {
              if (chartConfig.chart_type === 'line') return 3;
              if (chartConfig.chart_type === 'area') return 2;
              return 0; // column/bar
            }
            // Default to 3 for line charts if no config found
            return 3;
          });
  
          // Determine if we have any line/area charts (need smooth curve)
          const hasLineOrArea = charts.some(c => c.chart_type === 'line' || c.chart_type === 'area');
          
          // Ensure fill opacities match the number of series
          const fillOpacities = this.ordersSeries.map((series, index) => {
            const chartConfig = charts[index] || charts.find(c => c.label_name === series.name);
            if (chartConfig) {
              if (chartConfig.chart_type === 'area') return 0.85;
              if (chartConfig.chart_type === 'line') return 0.85; // No fill for line charts
              return 0.85; // column/bar
            }
            // Default to 0 (no fill) for line charts if no config found
            return 0;
          });
  
          // Determine chart type: if all are the same type, use that; otherwise default to 'line'
          let chartTypeOverride = 'line'; // default
          if (charts.length > 0) {
            const chartTypes = [...new Set(charts.map(c => c.chart_type))];
            if (chartTypes.length === 1) {
              chartTypeOverride = chartTypes[0] === 'column' ? 'bar' : chartTypes[0];
            } else {
              // Mixed types - default to line
              chartTypeOverride = 'line';
            }
          }
          const strokeConfig = hasLineOrArea 
            ? { 
                width: strokeWidths, 
                curve: "smooth"
              }
            : { 
                width: strokeWidths
              };
  
          // Build fill config conditionally - for line charts, fill should be transparent
          const fillConfig = hasLineOrArea
            ? { 
                opacity: fillOpacities,
                type: 'solid' // Use solid fill (transparent for lines)
              }
            : { 
                opacity: fillOpacities,
                gradient: {
                  inverseColors: false,
                  shade: "light",
                  type: "vertical",
                  opacityFrom: 0.85,
                  opacityTo: 0.55,
                  stops: [0, 100, 100, 100],
                }
              };
  
          const finalChartColors = dynamicColors.length > 0 ? dynamicColors : this.ordersChartOptions.colors;
          
          if (dynamicColors.length > 0) {
            this.ordersChartOptions = {
              ...this.ordersChartOptions,
              chart: { ...this.ordersChartOptions.chart, type: chartTypeOverride },
              colors: dynamicColors,
              stroke: strokeConfig,
              fill: fillConfig,
              xaxis: { ...this.ordersChartOptions.xaxis, categories: response.data.data.labels }
            };
          } else {
            this.ordersChartOptions = {
              ...this.ordersChartOptions,
              chart: { ...this.ordersChartOptions.chart, type: chartTypeOverride },
              stroke: strokeConfig,
              fill: fillConfig,
              xaxis: { ...this.ordersChartOptions.xaxis, categories: response.data.data.labels }
            };
          }
  
          // Store values for chart update after render
          updateData = {
            labels: response.data.data.labels,
            chartType: chartTypeOverride,
            colors: finalChartColors,
            strokeConfig: strokeConfig,
            fillConfig: fillConfig
          };
  
        } catch (error) {
          this.error = error.response?.data?.error ? error.response.data.error : "";
          this.failedmsg(this.error);
        } finally {
          this.loaderOrders = false;
          
          // Only update chart if we have updateData (successful response)
          if (updateData) {
            // Wait for chart to render after loader is set to false
            await this.$nextTick();
            
            // Wait a bit more for ApexCharts to initialize
            setTimeout(() => {
              if (this.$refs.ordersChart) {
                this.$refs.ordersChart.updateSeries(this.ordersSeries, false);
                this.$refs.ordersChart.updateOptions({
                  xaxis: { categories: updateData.labels },
                  chart: { type: updateData.chartType },
                  colors: updateData.colors,
                  stroke: updateData.strokeConfig,
                  fill: updateData.fillConfig,
                  markers: { size: 0 } // No markers for cleaner lines
                }, false, false);
              }
            }, 100);
          }
        }
      },
      
      async getMotmParticipationStats() {
        this.loaderMotm = true;
        try {
          const response = await Statistics.getMotmParticipation();
          
          if (response.data.data) {
            const data = response.data.data;
            this.motmTotalVotes = data.total_votes || 0;
            
            // Format chart data
            const chartData = data.chart_data || [];
            const labels = chartData.map(item => item.match_identifier);
            const votes = chartData.map(item => item.votes);
            
            this.motmSeries = [{
              name: "Votes",
              data: votes
            }];
            
            // Update chart options
            this.motmChartOptions = {
              ...this.motmChartOptions,
              xaxis: {
                ...this.motmChartOptions.xaxis,
                categories: labels
              }
            };
            
            // Calculate max value for y-axis
            if (votes.length > 0) {
              const maxValue = Math.max(...votes);
              this.motmChartOptions.yaxis = {
                ...this.motmChartOptions.yaxis,
                max: Math.ceil(maxValue * 1.1)
              };
            }
            
            // Update chart
            await this.$nextTick();
            if (this.$refs.motmChart) {
              this.$refs.motmChart.updateSeries(this.motmSeries, false);
              this.$refs.motmChart.updateOptions({
                xaxis: { 
                  categories: labels,
                  labels: {
                    hideOverlappingLabels: false,
                    showDuplicates: true,
                    maxHeight: 120,
                    rotate: -45,
                    rotateAlways: true,
                  }
                },
                yaxis: this.motmChartOptions.yaxis
              }, false, false);
              this.$refs.motmChart.refresh();
            }
          }
        } catch (error) {
          this.error = error.response?.data?.error || '';
          this.failedmsg(this.error);
        } finally {
          this.loaderMotm = false;
        }
      },
      
      async getGtsParticipationStats() {
        this.loaderGts = true;
        try {
          const response = await Statistics.getGtsParticipation();
          
          if (response.data.data) {
            const data = response.data.data;
            this.gtsTotalVotes = data.total_votes || 0;
            
            // Format chart data
            const chartData = data.chart_data || [];
            const labels = chartData.map(item => item.match_identifier);
            const votes = chartData.map(item => item.votes);
            
            this.gtsSeries = [{
              name: "Votes",
              data: votes
            }];
            
            // Update chart options
            this.gtsChartOptions = {
              ...this.gtsChartOptions,
              xaxis: {
                ...this.gtsChartOptions.xaxis,
                categories: labels
              }
            };
            
            // Calculate max value for y-axis
            if (votes.length > 0) {
              const maxValue = Math.max(...votes);
              this.gtsChartOptions.yaxis = {
                ...this.gtsChartOptions.yaxis,
                max: Math.ceil(maxValue * 1.1)
              };
            }
            
            // Update chart
            await this.$nextTick();
            if (this.$refs.gtsChart) {
              this.$refs.gtsChart.updateSeries(this.gtsSeries, false);
              this.$refs.gtsChart.updateOptions({
                xaxis: { 
                  categories: labels,
                  labels: {
                    hideOverlappingLabels: false,
                    showDuplicates: true,
                    maxHeight: 120,
                    rotate: -45,
                    rotateAlways: true,
                  }
                },
                yaxis: this.gtsChartOptions.yaxis
              }, false, false);
              this.$refs.gtsChart.refresh();
            }
          }
        } catch (error) {
          this.error = error.response?.data?.error || '';
          this.failedmsg(this.error);
        } finally {
          this.loaderGts = false;
        }
      },
      
      async getCustomerStatistics() {
        try {
          await Statistics.getCustomerStatistics(this.days, {})
            .then((response) => {
              const data = response.data.data || {};
              this.user_count = data.user_count ?? 0;
              this.user_count_weekly = data.user_count_weekly ?? 0;
              this.user_count_weekly_prev = data.user_count_weekly_prev ?? 0;
            })
            .catch((error) => {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error);
            });
        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error);
        }
      },
  
      async getSessionsStatistics() {
        try {
          await Statistics.getSessionsStatistics(this.days, {})
            .then((response) => {
              this.sessions_count_current = response.data.data.sessions_count;
              this.sessions_count_previous = response.data.data.compare_count;
              this.sessions_change_percent = response.data.data.change_percent;
            })
            .catch((error) => {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error);
            });
        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error);
        }
      },
  
      async getTopMerchandiseProducts() {
        this.topProductLoader = true;
        const today = new Date();
        let startDate = today;
        let endDate = today;
  
        if (this.dateOption === 'lastWeek') {
          const lastWeek = new Date();
          lastWeek.setDate(today.getDate() - 7);
          startDate = lastWeek;
        } else if (this.dateOption === 'monthly') {
          const last30Days = new Date();
          last30Days.setDate(today.getDate() - 30);
          startDate = last30Days;
        }
  
        this.dateRange = [startDate, endDate];
  
        const formatDate = (date) => {
          if (!date) return null;
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };
  
        const paramsObj = {
          limit: 5,
          date_from: formatDate(startDate),
          date_to: formatDate(endDate),
        };
  
        const queryParams = new URLSearchParams();
        for (const key in paramsObj) {
          if (paramsObj[key] !== null && paramsObj[key] !== undefined) {
            queryParams.append(key, paramsObj[key]);
          }
        }
  
        const queryString = queryParams.toString();
  
        try {
          const response = await Statistics.getTopMerchandiseProducts(queryString);
          this.topMerchProducts = response.data.data;
        } catch (error) {
          this.error = error.response?.data?.error || "";
          this.failedmsg(this.error);
        } finally {
          this.topProductLoader = false;
        }
      },
  
      handleDatePickerConfirm() {
        this.getTopMerchandiseProducts();
      },
      
      // FIXED: This method should NOT modify usersSeries - it's for a different chart!
      async getOrdersTotalsStatistics() {
        try {
          await Statistics.getOrdersTotalStatistics(this.days, {})
            .then((response) => {
              let orders_total_temp = response.data.data.orders_total;
              this.orders_total = parseFloat(orders_total_temp);
              this.orders_count = response.data.data.orders_count;
              this.change_percent = response.data.data.change_percent;
  
              let orders_per_day = response.data.data.orders_per_day;
              
              // FIXED: Modify realtimeSeries, NOT usersSeries
              this.realtimeSeries[0].data.splice(0, 1);
              orders_per_day.forEach((order) => {
                this.realtimeSeries[0].data.push(parseFloat(order.orders_total));
              });
            })
            .catch((error) => {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error);
            })
            .finally(() => {
              this.updateSeriesLine();
            });
        } catch (error) {
          //console.log(error)
        }
      },
  
      async getTicketingTotalsStatistics() {
        try {
          await Statistics.getTicketingTotalStatistics(this.days, {})
            .then((response) => {
              let ticketing_total_temp = response.data.data.orders_total;
              this.ticketing_orders_total = parseFloat(ticketing_total_temp);
              this.ticketing_count = response.data.data.orders_count;
              this.ticketing_change_percent = response.data.data.change_percent;
            })
            .catch((error) => {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error);
            });
        } catch (error) {
          //console.log(error)
        }
      },
  
      async getOrdersStatisticsByTypeTotalCount() {
        try {
          const response = await Statistics.getOrdersStatisticsByType(
            this.graph_days,
            this.graph_type,
            {}
          );
          if (response.data.data.data.length > 0) {
            this.showOrdersStatistics = true;
          } else {
            this.showOrdersStatistics = false;
          }
        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error);
          this.showOrdersStatistics = false;
        }
      },
  
      // FIXED: Update realtimeSeries, not usersSeries
      updateSeriesLine() {
        if (this.$refs.realtimeChart) {
          this.$refs.realtimeChart.updateSeries(this.realtimeSeries, false, true);
        }
      },
  
      goToURL(url) {
        window.location.href = "/" + url;
      },
  
      updateSalesChart(data) {
        this.salesSeries = data.data;
        if (this.graph_data_type == "customerDevices") {
          this.salesChartOptions = {
            labels: data.labels,
            colors: ["#5b73e8", "#f1b54d"],
            stroke: { width: [1, 5] },
            fill: { opacity: [0.85, 1] },
            yaxis: { title: { text: "" } },
          };
        } else if (this.graph_data_type == "orders") {
          this.salesChartOptions = {
            labels: data.labels,
            colors: ["#5b73e8", "#FF0000", "#f1b54d"],
            stroke: { width: [2, 2, 5] },
            fill: { opacity: [0.85, 0.25, 1] },
            yaxis: [
              { title: { text: "" } },
              { opposite: true, title: { text: "" } },
            ],
          };
        }
      },
  
      getGraphStatistics() {
        if (this.graph_data_type == "orders") {
          this.getOrdersStatisticsByType(this.graph_days, "daily");
        } else if (this.graph_data_type == "customerDevices") {
          this.getCustomerDevicesStatistics();
        }
      },
  
      getOrdersStatistics() {
        if (this.graph_data_type == "orders") {
          if (this.graph_type == "daily") {
            this.getOrdersStatisticsByType(this.graph_days, "daily");
          } else if (this.graph_type == "monthly") {
            this.getOrdersStatisticsByType(this.graph_months, "monthly");
          }
        } else if (this.graph_data_type == "customerDevices") {
          if (this.graph_type == "daily") {
            this.getCustomerDevicesStatistics();
          } else if (this.graph_type == "monthly") {
            this.getCustomerDevicesStatistics();
          }
        }
      },
  
      async getDashboardMessage() {
        this.message_show = false;
        try {
          await General.getDashboardMessage(this.dashboard_version, {})
            .then((response) => {
              this.message_text = response.data.data.text;
              this.message_button_text = response.data.data.button_text;
              this.message_button_link = response.data.data.button_link;
              this.message_button_color = response.data.data.button_color;
              this.message_button_text_color = response.data.data.button_text_color;
              this.message_image_url = response.data.data.img_url;
              this.message_background_color = response.data.data.background_color;
              this.button_color = response.data.data.button_color;
              this.button_text_color = response.data.data.button_text_color;
              this.message_text_color = response.data.data.text_color;
              this.message_video_url = response.data.data.video_url;
              this.message_show = true;
            })
            .catch((error) => {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error);
            });
        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error);
        }
      },
      
      formatDateTime(dateString) {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: false };
        const date = new Date(dateString);
        const formattedDate = date.toLocaleDateString("de-DE", options).replace(/\./g, ".");
        const formattedTime = date.toLocaleTimeString("en-GB", timeOptions);
        return `${formattedDate} ${formattedTime}`;
      },
      
      formatMatchDateTime(dateTimeString) {
        if (!dateTimeString) return '';
        return dateTimeString.replace(' ', ' at ').replace(':', '.');
      },
  
      async getSportMatchesCurrent() {
        try {
          const response = await Teams.getSportMatchesCurrent();
          const now = Math.floor(Date.now() / 1000);
  
          const formattedMatches = response.data.matches
            .map((match) => ({
              ...match,
              date_time: this.formatDateTime(match.date_time),
            }))
            .sort((match_a, match_b) => {
              const match_a_is_upcoming = match_a.unix_datetime !== null && match_a.unix_datetime >= now;
              const match_b_is_upcoming = match_b.unix_datetime !== null && match_b.unix_datetime >= now;
  
              if (match_a_is_upcoming && !match_b_is_upcoming) return -1;
              if (!match_a_is_upcoming && match_b_is_upcoming) return 1;
              if (match_a_is_upcoming && match_b_is_upcoming) return match_a.unix_datetime - match_b.unix_datetime;
              return match_b.unix_datetime - match_a.unix_datetime;
            });
  
          this.matches = formattedMatches;
          this.currentMatchIndex = 0;
        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
        }
      },
      
      callModalEditPreviewText(data) {
        this.$bvModal.show("edit_preview_text");
        this.modalData = data;
      },
  
      async getNotificationsStatistics() {
        this.notifDataLoader = true;
        let period = '&' + this.notificationsPeriodType;
        try {
          await Notification.getNotifications(1, 15, period)
            .then((response) => {
              this.notificationsData = [];
              if (response.data.total_items) {
                this.notificationsData = response.data.notifications;
              }
            })
            .catch((error) => {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error);
            });
        } catch (error) {
          //console.log(error)
        } finally {
          this.notifDataLoader = false;
        }
      },
  
      getNotificationLink(notification) {
        const isGroup = notification.notification_group;
        return {
          path: '/notifications/details',
          query: {
            id: isGroup ? notification.notification_group : notification.notification_id,
            type: isGroup ? 'group' : 'single'
          }
        };
      },
  
      nextMatch() {
        if (this.matches.length > 0) {
          this.currentMatchIndex = (this.currentMatchIndex + 1) % this.matches.length;
        }
      },
  
      previousMatch() {
        if (this.matches.length > 0) {
          this.currentMatchIndex = this.currentMatchIndex === 0 ? this.matches.length - 1 : this.currentMatchIndex - 1;
        }
      },
  
      getCurrentMatch() {
        return this.matches[this.currentMatchIndex] || null;
      }
    },
  };
  </script>
  
  <template>
    <div>
      <div class="row">
        <div class="col-12" style="margin-top: 0px; padding-top: 0px;" v-if="message_show">
          <div
            class="card"
            :style="{ backgroundColor: computedMessageBackground }"
          >
            <div class="card-body">
              <div class="d-flex align-items-center gap-3 flex-nowrap">
  
                <!-- TEXT + ACTION BUTTON -->
                <div class="d-flex align-items-center gap-3 flex-grow-1">
                  <p
                    class="font-size-18 mb-0"
                    v-html="computedMessageText"
                    :style="{ color: computedMessageTextColor }"
                  ></p>
  
                  <a
                    v-if="message_button_link"
                    :href="message_button_link"
                    class="btn btn-sm flex-shrink-0"
                    :style="{
                      padding: '0 4px 0 4px',
                      backgroundColor: computedButtonColor,
                      color: computedButtonTextColor,
                      borderColor: computedButtonColor
                    }"
                  >
                    {{ message_button_text }}
                  </a>
  
                  <button
                    v-if="message_video_url"
                    type="button"
                    class="btn btn-sm flex-shrink-0"
                    style="background-color: transparent; color: #ffffff; border: none; font-size: 0.9rem;"
                    @click="showMessageVideoModal = true"
                  >
                    Watch video
                  </button>
                </div>
  
                <!-- CLOSE BUTTON (END) -->
                <button
                  type="button"
                  class="btn btn-sm flex-shrink-0"
                  style="background-color: transparent; color: #ffffff; border: none; font-size: 1rem;"
                  @click="message_show = false"
                  aria-label="Close"
                >
                  ✕
                </button>
  
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="row">
     
      <div class="col-md-6 col-xl-3" style="margin-bottom: 0px;" v-if="showActiveSession">
        <div class="card" >
          <div class="card-body">
            <div v-if="matches.length > 0">
              <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 0.75rem;">
                <div class="d-flex align-items-center gap-1">
                  <span v-if="getCurrentMatch().match_status !== 'Played'" class="text-muted" style="font-size: 0.9rem; margin-right: 5px;">
                    Next match
                  </span>
                  <span v-else class="text-muted" style="font-size: 0.9rem; margin-right: 5px;">
                    Previous match
                  </span>
                  <span style="font-size: 0.8rem; line-height: 1.1; margin-top: 2px;">
                    {{ getCurrentMatch().home_team_code }}
                  </span>
                  <img
                    :src="getCurrentMatch().home_team_logo"
                    class="rounded-circle"
                    alt="Home team logo"
                    style="width: 23px; height: 23px; object-fit: cover;"
                    onerror="this.style.display='none'"
                  />
                

                  <span v-if="getCurrentMatch().match_status !== 'Played'" class="text-muted" style="font-size: 0.6rem;">
                    VS
                  </span>
                  <span v-else class="fw-semibold" style="font-size: 0.9rem;">
                    {{ getCurrentMatch().score_home }} : {{ getCurrentMatch().score_away }}
                  </span>

                  <img
                    :src="getCurrentMatch().away_team_logo"
                    class="rounded-circle"
                    alt="Away team logo"
                    style="width: 23px; height: 23px; object-fit: cover;"
                    onerror="this.style.display='none'"
                  />
                  <span style="font-size: 0.8rem; line-height: 1.1; margin-top: 2px;">
                    {{ getCurrentMatch().away_team_code }}
                  </span>
                </div>

                <div
                  style="background-color: #DBFCE7; padding: 9px 10px; border-radius: 9px;
                        display: inline-flex; align-items: center; justify-content: center;"
                >
                  <i class="fas fa-calendar" style="color: #28a745; font-size: 1.1rem;"></i>
                </div>
              </div>
             
              <div class="mb-0">
                <p class="mb-0" style="font-size: 1.2rem; color: #212529;">
                  {{ formatMatchDateTime(getCurrentMatch().date_time) }}
                </p>
              </div>
              <div class="mt-0 d-flex justify-content-between align-items-center" v-if="getCurrentMatch().match_status !== 'Played'">
                <div> 
                  <span class="mb-0" style="font-size: 1.2rem; color: #212529;"> 
                {{ getCurrentMatch().competition_name }} 
                  </span>
                <a
                  href="javascript:void(0);"
                  class="text-primary"
                  style="font-size: 0.85rem; text-decoration: none;"
                  v-b-tooltip.hover
                  title="View preview text"
                  @click="callModalEditPreviewText(getCurrentMatch())"
                >
                (preview)
                </a>
              </div>
                <div
                  v-if="matches.length > 1"
                  class="d-flex"
                  style="gap: 10px;"
                >
                  <button
                    @click="previousMatch()"
                    class="btn btn-link p-0"
                    style="color: #6c757d; text-decoration: none; padding: 2px 4px;"
                    type="button"
                  >
                    <i class="fas fa-chevron-left" style="font-size: 0.9rem;"></i>
                  </button>
                  <button
                    @click="nextMatch()"
                    class="btn btn-link p-0"
                    style="color: #6c757d; text-decoration: none; padding: 2px 4px;"
                    type="button"
                  >
                    <i class="fas fa-chevron-right" style="font-size: 0.9rem;"></i>
                  </button>
                </div>
              </div>
              <div v-else class="mt-0 d-flex align-items-center">
                <div class="flex-grow-1 d-flex justify-content-start">
                  <span class="mb-0" style="font-size: 1.2rem; color: #212529;"> 
                {{ getCurrentMatch().competition_name }} 
                  </span>
                </div>
                <div
                  v-if="matches.length > 1"
                  class="d-flex"
                  style="gap: 10px;"
                >
                  <button
                    @click="previousMatch()"
                    class="btn btn-link p-0"
                    style="color: #6c757d; text-decoration: none; padding: 2px 4px;"
                    type="button"
                  >
                    <i class="fas fa-chevron-left" style="font-size: 0.9rem;"></i>
                  </button>
                  <button
                    @click="nextMatch()"
                    class="btn btn-link p-0"
                    style="color: #6c757d; text-decoration: none; padding: 2px 4px;"
                    type="button"
                  >
                    <i class="fas fa-chevron-right" style="font-size: 0.9rem;"></i>
                  </button>
                </div>
              </div>
            </div>
            <div v-else class="text-center">
              <p class="text-muted mb-0" style="font-size: 0.85rem;">No matches available</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3" style="margin-bottom: 0px;" v-if="showRegisteredUsers">
        <div class="card">
          <div class="card-body elementPointed" @click="goToURL('customers')">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-muted" style="font-size: 1rem;">Registered users</span>
              <div
                class="d-flex justify-content-center align-items-center"
                style="width: 36px; height: 36px; border-radius: 12px; background-color: #e6f0ff;"
              >
                <i class="fas fa-users" style="color: #3b82f6; font-size: 1.1rem;"></i>
              </div>
            </div>
            <div class="mb-1">
              <h4 class="mb-0" style="font-weight: 400;">
                <span data-plugin="counterup">
                  <countTo
                    :startVal="0"
                    :endVal="user_count"
                    :duration="2000"
                  ></countTo>
                </span>
                <span> users</span>
              </h4>
            </div>
            <p
              class="mt-2 mb-0"
              :class="user_count_weekly >= 0 ? 'text-success' : 'text-danger'"
              style="font-size: 0.9rem;"
            >
              {{ user_count_weekly >= 0 ? '+' + user_count_weekly : user_count_weekly }}
              in last {{ days }} days
            </p>
          </div>
        </div>
      </div>
      
  
      <!--
      <div class="col-md-6 col-xl-3">
          <div class="card">
              <div class="card-body elementPointed">
                  <div class="float-end mt-2">
                      <i class="fas fa-mobile-alt fa-3x"></i>
                  </div>
                  <div>
                      <h4 class="mb-1 mt-1">
                          <span data-plugin="counterup">
                              <countTo :startVal="0" :endVal="device_count_current" :duration="2000"></countTo>
                          </span>
                      </h4>
                      <h5 class="text-muted mb-0">Active devices ({{days}} days)</h5>
                  </div>
                  <p class="text-muted mt-3 mb-0">
                      <span v-if="device_change_percent >= 0" class="text-success me-1">
                         <i class="mdi mdi-arrow-up-bold me-1 font-size-16"></i>{{device_change_percent}}%
                      </span>
                      <span v-else class="text-danger me-1 font-size-16">
                          <i class="mdi mdi-arrow-down-bold me-1 font-size-16"></i>{{device_change_percent}}%</span>
                      vs. previous {{days}} days
                  </p>
              </div>
          </div>
      </div>
  -->
  
  
      <div class="col-md-6 col-xl-3" style="margin-bottom: 0px;" v-if="showOrders">
        <div class="card">
          <div class="card-body elementPointed" @click="goToURL('orders')">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-muted" style="font-size: 0.95rem;">
                Order revenue (last {{ days }} days)
              </span>
              <div
                class="d-flex justify-content-center align-items-center"
                style="width: 36px; height: 36px; border-radius: 12px; background-color: #f3e8ff;"
              >
                <i class="fas fa-dollar-sign" style="color: #a855f7; font-size: 1.1rem;"></i>
              </div>
            </div>
            <div class="mb-1">
              <h4 class="mb-0" style="font-weight: 400;">
                <span data-plugin="counterup">
                <countTo
                    :startVal="0.0"
                    :endVal="orders_total"
                    :decimals="2"
                    decimal="."
                    :duration="2000"
                  ></countTo>
                </span>
              </h4>
            </div>
            <p
              class="mt-2 mb-0"
              v-if="change_percent !== null"
              :class="change_percent >= 0 ? 'text-success' : 'text-danger'"
              style="font-size: 0.9rem;"
            >
              {{ change_percent >= 0 ? '+' + change_percent : change_percent }}% vs. previous period
            </p>
            <p
              v-else
              class="mt-2 mb-0 text-muted"
              style="font-size: 0.9rem;"
            >
              No data to compare with
            </p>
          </div>
        </div>
      </div>
      <!-- end col-->
  
      <div class="col-md-6 col-xl-3" style="margin-bottom: 0px;"  v-if="showTicketing">
        <div class="card">
          <div class="card-body elementPointed">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-muted" style="font-size: 0.95rem;">
                Ticketing revenue (last {{ days }} days)
              </span>
              <div
                class="d-flex justify-content-center align-items-center"
                style="width: 36px; height: 36px; border-radius: 12px; background-color: #fff4e6;"
              >
                <i class="fas fa-ticket-alt" style="color: #f97316; font-size: 1.1rem;"></i>
              </div>
            </div>
            <div class="mb-1">
              <h4 class="mb-0" style="font-weight: 400;">
                <span data-plugin="counterup">
                  &euro;<countTo
                    :startVal="0.0"
                    :endVal="ticketing_orders_total"
                    :decimals="2"
                    decimal="."
                    :duration="2000"
                  ></countTo>
                </span>
              </h4>
            </div>
            <p
              class="mt-2 mb-0"
              v-if="ticketing_change_percent !== null"
              :class="ticketing_change_percent >= 0 ? 'text-success' : 'text-danger'"
              style="font-size: 0.9rem;"
            >
              {{ ticketing_change_percent >= 0 ? '+' + ticketing_change_percent : ticketing_change_percent }}% vs. previous period
            </p>
            <p
              v-else
              class="mt-2 mb-0 text-muted"
              style="font-size: 0.9rem;"
            >
              No data to compare with
            </p>
          </div>
        </div>
      </div>
      
      <!-- end col-->
  
      <!--!!!sales chart is used to plot customers and devices data also-->
  
      <div class="col-12 col-md-12" style="margin-top: 0px; padding-top: 0px;">
        <div class="row">
          <!-- First Row - First Card -->
          <div class="col-12 col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <span class="h5 ms-3 d-block d-md-inline">New Registered Users</span>
                <div class="col-auto p-0 select-wrapper float-end">
                  <select
                          v-model="graph_type_users"
                          class="form-select"
                          @change="getCustomerDevicesStatistics()"
                          style="padding-right: 2rem; background-color: #f8f9fa;"
                  >
                    <option value="daily" selected>Last 30 Days</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </div>
                <div class="clearfix"></div>
                <div class="d-flex justify-content-between w-100 mt-3"> 
                  <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                    Avg. Daily new registrations
                  </p>
                  <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                    Last Day
                  </p>
                </div>
                
                <div class="d-flex justify-content-between align-items-baseline ms-3 mb-2" style="gap: 8px;">
                  <div>
                    <span style="font-size: 1.6rem; font-weight: 400;">
                      {{ Math.round(avgDailyNewRegistrations) }}
                    </span>
                    <span
                      v-if="avgDailyNewRegistrationsChangePercent !== null"
                      :class="avgDailyNewRegistrationsChangePercent >= 0 ? 'text-success' : 'text-danger'"
                      style="font-size: 0.9rem; font-weight: 400;"
                    >
                      <span v-if="avgDailyNewRegistrationsChangePercent >= 0">↗</span>
                      <span v-else>↘</span>
                      {{ avgDailyNewRegistrationsChangePercent >= 0 ? '+' : '' }}{{ avgDailyNewRegistrationsChangePercent.toFixed(1) }}%
                    </span>
                  </div>
                  <span style="font-size: 1.6rem; font-weight: 400;">
                    {{ lastDayNewRegistrations }}
                  </span>
                </div>
  
                <apexchart
                        v-if="!loaderRegUsers"
                        id="usersChart"
                        data-colors='["--bs-primary", "#dfe2e6"]'
                        class="apex-charts"
                        ref="usersChart"
                        :options="usersChartOptions"
                        :series="usersSeries"
                >
                </apexchart>
                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                  <b-spinner large></b-spinner>
                </div>
              </div>
            </div>
          </div>
  
          <!-- First Row - Second Card -->
          <div class="col-12 col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <span class="ms-3 h5 d-block d-md-inline">Orders - Revenue Breakdown</span>
                <div class="col-auto p-0 select-wrapper float-end">
                  <select
                          v-model="graph_type_orders"
                          class="form-select"
                          @change="getOrdersStatisticsByType()"
                          style="padding-right: 2rem; background-color: #f8f9fa;"
                  >
                    <option value="daily" selected>Last 30 Days</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </div>
                <div class="clearfix"></div>
                <div class="d-flex justify-content-between w-100 mt-3"> 
                  <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                  Avg. Daily Revenue
                </p>
                <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                  Last Day
                </p>
                </div>
                <div class="d-flex justify-content-between align-items-baseline ms-3 mb-1" style="gap: 8px;">
                  <div>
                    <span style="font-size: 1.6rem; font-weight: 400;">
                    €{{ avgDailyRevenue.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                  </span>
                  <span
                    v-if="change_percent !== null"
                    :class="change_percent >= 0 ? 'text-success' : 'text-danger'"
                    style="font-size: 0.9rem; font-weight: 400;"
                  >
                    <span v-if="change_percent >= 0">↗</span>
                    <span v-else>↘</span>
                    {{ change_percent >= 0 ? '+' : '' }}{{ change_percent.toFixed(1) }}%
                  </span>
                  </div>
                 
                  <span style="font-size: 1.6rem; font-weight: 400;">
                    €{{ lastDayRevenue.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                  </span>
                </div>
               
                    <apexchart
                        id="ordersChart"
                        v-if="!loaderOrders"
                        data-colors='["--bs-primary", "#FF0000", "--bs-warning"]'
                        class="apex-charts"
                        ref="ordersChart"
                        :options="ordersChartOptions"
                        :series="ordersSeries"
                    >
                    </apexchart>
                  <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-if="loaderOrders">
                    <b-spinner large></b-spinner>
                  </div>
 <!--              <div v-if="loaderOrders && showOrdersStatistics">-->
 <!--                <p style="text-align: center; padding-top: 100px; font-size: 6em; color: #5b73e8;">-->
 <!--                  <i class="uil-folder-slash"></i>-->
 <!--                </p>-->
 <!--                <p style="text-align: center; margin-top: -20px; font-weight: bold;">No data available</p>-->
 <!--              </div>-->
              </div>
            </div>
          </div>
          
          <!-- MOTM Chart Card -->
          <div class="col-12 col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <span class="ms-3 h5 d-block d-md-inline">Man of the Match - Participation</span>
                <div class="clearfix"></div>
                <div class="d-flex justify-content-between w-100 mt-3"> 
                  <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                    Total Votes
                  </p>
                </div>
                <div class="d-flex justify-content-between align-items-baseline ms-3 mb-1" style="gap: 8px;">
                  <div>
                    <span style="font-size: 1.6rem; font-weight: 400;">
                      {{ motmTotalVotes.toLocaleString() }}
                    </span>
                  </div>
                </div>
               
                <apexchart
                        id="motmChart"
                        v-if="!loaderMotm"
                        data-colors='["#3B82F6"]'
                        class="apex-charts"
                        ref="motmChart"
                        :options="motmChartOptions"
                        :series="motmSeries"
                >
                </apexchart>
                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-if="loaderMotm">
                  <b-spinner large></b-spinner>
                </div>
              </div>
            </div>
          </div>
          
          <!-- GTS Chart Card -->
          <div class="col-12 col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <span class="ms-3 h5 d-block d-md-inline">Guess the Score - Participation</span>
                <div class="clearfix"></div>
                <div class="d-flex justify-content-between w-100 mt-3"> 
                  <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                    Total Votes
                  </p>
                </div>
                <div class="d-flex justify-content-between align-items-baseline ms-3 mb-1" style="gap: 8px;">
                  <div>
                    <span style="font-size: 1.6rem; font-weight: 400;">
                      {{ gtsTotalVotes.toLocaleString() }}
                    </span>
                  </div>
                </div>
               
                <apexchart
                        id="gtsChart"
                        v-if="!loaderGts"
                        data-colors='["#22c55e"]'
                        class="apex-charts"
                        ref="gtsChart"
                        :options="gtsChartOptions"
                        :series="gtsSeries"
                >
                </apexchart>
                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-if="loaderGts">
                  <b-spinner large></b-spinner>
                </div>
              </div>
            </div>
          </div>
        <div class="col-12 col-md-6">
          <div class="card" :style="!loaderUsersByGender ? { height: '490px' } : {}">
            <div class="card-body" :style="!loaderUsersByGender ? { height: '100%', overflowY: 'auto' } : {}">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <span class="h5 mb-0">Users by Gender</span>
              </div>
              
              <div class="mb-3" v-if="!loaderUsersByGender">
                <div class="text-muted small mb-1">Total Users</div>
                <div class="h3 mb-0">{{ usersByGenderTotal.toLocaleString() }}</div>
              </div>
              
              <div v-if="loaderUsersByGender" class="d-flex align-items-center justify-content-center py-5">
                <b-spinner large></b-spinner>
              </div>
              
              <div v-else-if="usersByGenderData.length > 0" class="mt-4">
                <div>
                  <div v-for="(item, index) in usersByGenderData" :key="index" class="mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div class="d-flex align-items-center" style="gap: 8px;">
                        <div 
                          class="rounded-circle" 
                          :style="{ 
                            width: '12px', 
                            height: '12px', 
                            backgroundColor: getColorForGender(item.color)
                          }"
                        ></div>
                        <span class="small">{{ item.label }}</span>
                      </div>
                      <span class="small">{{ item.percentage }}% ({{ item.count.toLocaleString() }})</span>
                    </div>
                    <div class="progress" style="height: 8px; background-color: #e5e7eb;">
                      <div 
                        class="progress-bar rounded-pill"
                        :style="{
                          width: item.percentage + '%',
                          backgroundColor: getColorForGender(item.color)
                        }"
                        role="progressbar"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-else class="text-center text-muted py-4">
                No data available
              </div>
            </div>
          </div>
        </div>
  
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <span class="h5 mb-0">Users by Age</span>
              </div>
              
              <div class="mb-3" v-if="!loaderUsersByAge">
                <div class="text-muted small mb-1">Total Users</div>
                <div class="h3 mb-0">{{ usersByAgeTotal.toLocaleString() }}</div>
              </div>
              
              <div v-if="loaderUsersByAge" class="d-flex align-items-center justify-content-center py-5">
                <b-spinner large></b-spinner>
              </div>
              
              <div v-else-if="usersByAgeData.length > 0" class="mt-4">
                <div>
                  <div v-for="(item, index) in usersByAgeData" :key="index" class="mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <span class="small">{{ item.label }}</span>
                      <span class="small">{{ item.count.toLocaleString() }}</span>
                    </div>
                    <div class="progress" style="height: 8px; background-color: #e5e7eb;">
                      <div 
                        class="progress-bar rounded-pill" 
                        :style="{ width: item.percentage + '%', backgroundColor: '#f97316' }"
                        role="progressbar"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-else class="text-center text-muted py-4">
                No data available
              </div>
            </div>
          </div>
        </div>
  
          <div class="col-12 col-md-6" style="margin-bottom: 2rem;">
            <div class="card h-100">
              <div class="card-body">
                <span class="ms-3 h5 d-block d-md-inline">Push Notifications</span>
                <div class="col-auto p-0 select-wrapper float-end">
                  <select
                          v-model="notificationsPeriodType"
                          class="form-select"
                          @change="getNotificationsStatistics()"
                          style="padding-right: 2rem; background-color: #f8f9fa;"
                  >
                    <option value="daily">Today</option>
                    <option value="monthly" selected>Last 30 days</option>
                  </select>
                </div>
                <div class="clearfix"></div>
                <div v-if="!notifDataLoader && notificationsData.length > 0" class="d-flex justify-content-between ms-3 mt-3 mb-3" style="gap: 20px;">
                  <div>
                    <div class="text-muted mb-1">Total Success</div>
                    <div class="h6 mb-0" style="font-size: 1.2rem; font-weight: 400;">{{ notificationsTotalSuccess }}</div>
                  </div>
                  <div>
                    <div class="text-muted mb-1">Total Failed</div>
                    <div class="h6 mb-0" style="font-size: 1.2rem; font-weight: 400;">{{ notificationsTotalFailed }}</div>
                  </div>
                  <div>
                    <div class="text-muted mb-1">Total Clicks</div>
                    <div class="h6 mb-0" style="font-size: 1.2rem; font-weight: 400;">{{ notificationsTotalClicks }}</div>
                  </div>
                </div>
  
                <div class="col-12 table-responsive">
                  <table class="table mb-0">
                    <thead>
                    <tr>
                      <th>Title</th>
                      <th>Success</th>
                      <th>Failed</th>
                      <th>Clicks</th>
                    </tr>
                    </thead>
                    <tbody v-if="!notifDataLoader">
                    <template v-if="notificationsData.length">
                      <tr v-for="notification in notificationsData.slice(0, 5)" :key="notification.notification_id">
                        <td>
                          <router-link :to="getNotificationLink(notification)">
                            {{ notification.title }}
                          </router-link>
                        </td>
                        <td>
                          <span v-if="notification.success != null">{{ notification.success }}</span>
                          <span v-else>N/A</span>
                        </td>
                        <td>
                          <span v-if="notification.error != null">{{ notification.error }}</span>
                          <span v-else>N/A</span>
                        </td>
                        <td>
                          <span v-if="notification.clicks != null">{{ notification.clicks }}</span>
                          <span v-else>N/A</span>
                        </td>
                      </tr>
  
                      <tr v-if="notificationsData.length > 5">
                        <td colspan="4" class="text-center">
                          <router-link to="/notifications">See all notifications</router-link>
                        </td>
                      </tr>
                    </template>
  
                    <template v-else>
                      <tr>
                        <td colspan="4" class="mt-3 text-center">No Data</td>
                      </tr>
                    </template>
                    </tbody>
                    <tbody v-else>
                    <tr>
                      <td colspan="4" class="mt-3 text-center">
                        <div class="d-flex justify-content-center">
                          <b-spinner large></b-spinner>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-12 col-md-6" style="margin-bottom: 2rem;">
            <div class="card h-100">
              <div class="card-body">
                <span class="ms-3 h5 d-block d-md-inline">Best Sellers</span>
                <div class="col-auto p-0 select-wrapper float-end">
                  <select
                          v-model="dateOption"
                          class="form-select"
                          @change="getTopMerchandiseProducts()"
                          style="padding-right: 2rem; background-color: #f8f9fa;"
                  >
                    <option value="today">Today</option>
                    <option value="lastWeek">Last 7 days</option>
                    <option value="monthly" selected>Last 30 days</option>
                  </select>
                </div>
                <div class="clearfix"></div>
                
                <div v-if="!topProductLoader && topMerchProducts.length > 0" class="ms-3 mt-3 mb-3">
                  <div class="text-muted mb-1">Total Revenue</div>
                  <div class="h6 mb-0" style="font-size: 1.2rem; font-weight: 400;">€ {{ bestSellersTotalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</div>
                </div>
  
                <div class="col-12 table-responsive">
                  <table class="table mb-0">
                    <thead>
                    <tr>
                      <th>Product</th>
                      <th>Revenue</th>
                    </tr>
                    </thead>
                    <tbody v-if="!topProductLoader">
                    <template v-if="topMerchProducts.length">
                      <tr v-for="(product, index) in topMerchProducts" :key="index">
                          <td>{{ product.description }}</td>
                        <td>€ {{ product.total_revenue }}</td>
                      </tr>
  
                      <tr v-if="topMerchProducts.length">
                        <td colspan="4" class="text-center">
                          <router-link to="/best_sellers">View All</router-link>
                        </td>
                      </tr>
                    </template>
  
                    <template v-else>
                      <tr>
                        <td colspan="4" class="mt-3 text-center">No Data</td>
                      </tr>
                    </template>
                    </tbody>
                    <tbody v-else>
                    <tr>
                      <td colspan="4" class="mt-3 text-center">
                        <div class="d-flex justify-content-center">
                          <b-spinner large></b-spinner>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- Close first row -->
  
      </div>
      </div>
      <!-- end col-->
  
      <!-- Message video modal -->
      <div
        v-if="showMessageVideoModal"
        class="modal fade show"
        tabindex="-1"
        role="dialog"
        style="display: block; background: rgba(0, 0, 0, 0.5);"
        aria-modal="true"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Message video</h5>
              <button
                type="button"
                class="close btn btn-sm btn-link"
                @click="showMessageVideoModal = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center">
              <video
                v-if="message_video_url"
                :src="message_video_url"
                class="img-fluid rounded"
                style="max-width: 100%; height: auto;"
                controls
                autoplay
              ></video>
              <p v-else class="mb-0 text-muted">No video available.</p>
            </div>
          </div>
        </div>
      </div> <!-- Close modal div -->
  
      <modalEditPreviewText
        :fixture="modalData"
        @onRefresh="getSportMatchesCurrent"
      ></modalEditPreviewText>
    </div> <!-- Close the outermost div -->
    
  </template>
  <style scoped>
  .v-carousel__controls {
    background-color: red;
  }
  /* For regular bar charts */
  /* Add this to your component's style section */
  :deep(.apexcharts-bar-area) {
    stroke-linecap: round !important;
    stroke-linejoin: round !important;
    /* Add a subtle shadow to create rounded effect */
    filter: drop-shadow(0 0 1px rgba(0,0,0,0.1));
  }
  
  /* Or use SVG filter for rounded effect */
  :deep(svg) {
    filter: url(#roundCorners);
  }
  .card {
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 0 !important;
  }
  .card-title {
    font-weight: 500;
  }
  .dropdown-toggle {
    font-size: 14px;
  }

  /* Smaller selects only in this component */
  .form-select {
    font-size: 0.8rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }

  /* Make small header selects more responsive */
  .select-wrapper .form-select {
    width: auto;
    min-width: 130px;
    white-space: nowrap;
  }

  @media (max-width: 576px) {
    .select-wrapper {
      width: 100%;
      margin-top: 0.5rem;
    }
    .select-wrapper .form-select {
      width: 100%;
      min-width: 0;
    }
  }
  canvas {
    height: 250px !important;
  }
  .chart-container {
    position: relative;
    height: 270px;
  }
  </style>
